/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_3Inputs */

const en_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I stop bud rot?`)
};

const th_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้องกันดอกเน่าอย่างไร`)
};

const ja_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I stop bud rot?`)
};

const fr_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I stop bud rot?`)
};

const es_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I stop bud rot?`)
};

const ru_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I stop bud rot?`)
};

const zh_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I stop bud rot?`)
};

const vi_chat_suggestion_3 = /** @type {(inputs: Chat_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm sao để ngăn thối búp?`)
};

/**
* | output |
* | --- |
* | "How do I stop bud rot?" |
*
* @param {Chat_Suggestion_3Inputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_3 = /** @type {((inputs?: Chat_Suggestion_3Inputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_3Inputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_suggestion_3(inputs)
	if (locale === "ja") return ja_chat_suggestion_3(inputs)
	if (locale === "fr") return fr_chat_suggestion_3(inputs)
	if (locale === "es") return es_chat_suggestion_3(inputs)
	if (locale === "ru") return ru_chat_suggestion_3(inputs)
	if (locale === "zh") return zh_chat_suggestion_3(inputs)
	if (locale === "vi") return vi_chat_suggestion_3(inputs)
	return en_chat_suggestion_3(inputs)
});